exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".user-ranking-highlight-box[data-v-70850578]{background:#fff9e5;font-size:12px;font-weight:700;color:#b22c27;width:100%}", ""]);
